module.exports = __webpack_public_path__ + "img/HC1032-169.b41145f7.jpg";